import React from 'react';
import ApolloWrapper, { Props as ApolloWrapperProps } from './ApolloWrapper';

//local e2e testing only: rendered instead of the MSAL wrapper when
//REACT_APP_MOCK_AUTH=true, so the app boots without an Azure AD login
const mockAccount = {
  homeAccountId: 'mock-home-account',
  localAccountId: 'mock-local-account',
  username: 'e2e.tester@corticacare.com',
  name: 'E2E Tester'
};

const acquireToken = async () => 'mock-access-token';
const handleLogout = async () => {};

export default function MockAuthWrapper({
  children
}: {
  children: ApolloWrapperProps['children'];
}) {
  return (
    <ApolloWrapper
      activeAccount={mockAccount}
      acquireToken={acquireToken}
      handleLogout={handleLogout}
      children={children}
    />
  );
}
